export default __webpack_public_path__ + "static/media/Fence's Tunic of Ushering Twilight.3ff9d488.jpg";